import React from "react";
import { Helmet } from "react-helmet-async";
import { Container } from "react-bootstrap";

import QDLoader from "../../../components/QDLoader";
import Analytics from "../../../components/bots/analytics/Analytics";
import Header from "./Header";
import useBots from "../../../hooks/useBots";
import { useTranslation } from "../../../hooks/useLocalization";

const AnalyticsPage = () => {
  const { t } = useTranslation();
  const { isInitialized } = useBots();
  return (
    <React.Fragment>
      <Helmet title={t("Analytics")} />
      <Container fluid className="p-0">
        {isInitialized && <Header />}
        {isInitialized ? <Analytics /> : <QDLoader />}
      </Container>
    </React.Fragment>
  );
};

export default AnalyticsPage;
